import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import "./Home.css";
import { Image } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import F from './icons/faq1.jpg';
import certificateimg from './icons/GICertificate.png';
import stages from './icons/stages.png';
import logo from "./icons/giLogo.jpg";
import lg from "./icons/lg.png";
import A from "./icons/icons8-msg.png";
import B from "./icons/icons8-call.png";
import C from "./icons/icons8-location-24.png";
import company from "./icons/company.png";
import bannerquote from './icons/bannertech.png';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
const Home = () => {
    const dataText =[
        'Learn Frontend Development...',
        'Build Projects with React.js...',
        'Write Professional Emails...',
        'Enhance Your Coding Skills...',
        'Discover Career-Boosting Skills...',
        'Level Up in Web Development...',
        'Discover Career-Boosting Skills...',
        'Become a Full-Stack Developer...',
        'Explore UI/UX Design Techniques...',
        'Learn Certified Courses...',
      ]
    const TYPING_SPEED = 150;
const DELETING_SPEED = 30;
const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(TYPING_SPEED);

  useEffect(() => {
    const handleType = () => {
      const i = loopNum % dataText.length;
      const fullText = dataText[i];

      setText((prev) =>
        isDeleting
          ? fullText.substring(0, prev.length - 1)
          : fullText.substring(0, prev.length + 1)
      );

      setTypingSpeed(isDeleting ? DELETING_SPEED : TYPING_SPEED);

      if (!isDeleting && text === fullText) {
        setTimeout(() => setIsDeleting(true), 500);
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const typingTimeout = setTimeout(handleType, typingSpeed);

    return () => clearTimeout(typingTimeout);
  }, [text, isDeleting, loopNum, typingSpeed, dataText]);
  return (
    <>
    <div className="header d-flex justify-content-between">
        <img className="header-logo" src={lg} alt="logo"/>
        {/* <button className="button-71">Get In Touch</button> */}

    </div>
     <div className='banner-main-container pt-5' style={{marginBottom:'180px'}}>
      <div className='banner-img '>
        <img className='quote-img-banner' src={bannerquote} alt='' />
      </div>
    </div>
    <div className='certificate-container pt-5'>
      <h4 className='text-center certificate-text mt-2'>Certifications</h4>
      <div className='certificate-division d-lg-flex'>
        <div className='certificate-img-container'>
          <img
            className='certificate-img py-lg-5 my-1'
            src={certificateimg}
            alt=''
          />
        </div>
        <div className='certificate-para1  px-5 '>
          <p className='certificate-para2  mt-lg-5 py-lg-2'>
            A certificate from Graphene Infotech holds significant value due to
            the company’s strong industry reputation and focus on practical,
            hands-on training.
          </p>

          <p className='certificate-para3   text-xl mt-4'>
            Those who clear the practical exams will get enrolled in a six-month
            internship program.
          </p>
          <img className='stages mt-4 d-none d-lg-block' src={stages} alt='' />
        </div>
      </div>
    </div>
    <div className='pj'>
      <h4 className="my-4 pt-5 text-center">Projects & Trainings</h4>
    <div className="d-flex mx-auto justify-content-center">
        
        <img className="companies" src={company} alt="auto"/>
    </div>
    </div>
    <div className='my-5 typing-container'>
      <div className='typing-text'>
        <p>
          <span className='typing-span'>{text}</span>
          <span id='cursor'></span>
        </p>
      </div>
    </div>
    <div className='course-banner py-auto'>
      <div className='banner-container d-lg-flex justify-content-center'>
        <div className='banner-sm-screen d-lg-none d-xl-none'>
          <img
            src='https://img.freepik.com/free-vector/tiny-programmers-big-laptop-writing-script-coders-app-developers-with-computers-flat-vector-illustration-programming-engineering-software-development-concept-banner-landing-web-page_74855-25360.jpg?uid=R139239883&ga=GA1.1.1110932627.1730523152&semt=ais_hybrid'
            alt='amico'
            style={{ height: '60vw', objectFit: 'contain' }}
          />
        </div>
        <div className='pb-5 fee-text text-center'>
          <p className='mt-5 banner-text lg:text-start '>
            Unlock new career opportunities.
            <br />
            Get started with Graphene InfoTech
            <br />
            for just <br />
            <span className='offered-price'>₹9,999 </span>
            <span className='actual-price'>
              <s>₹19,999</s>
            </span>
          </p>
          {/* <p></p> */}
          <div className=' btn-container-banner d-lg-flex lg:justify-between'>
            <button
              className='join-btn1 p-2'
            >
              Register Soon
            </button>
            
          </div>
        </div>
        <div className=' banner-right mx-5 d-none d-lg-block '>
          <img
            src='https://img.freepik.com/free-vector/tiny-programmers-big-laptop-writing-script-coders-app-developers-with-computers-flat-vector-illustration-programming-engineering-software-development-concept-banner-landing-web-page_74855-25360.jpg?uid=R139239883&ga=GA1.1.1110932627.1730523152&semt=ais_hybrid'
            alt='amico'
            style={{ width: '32vw', height: '20vw', objectFit: 'contain' }}
          />
          {/* <div className='banner-inside'>
            <p className='actual-price'>
              <span className='striked-price'>₹ 19,999</span>
            </p>
            <p className='offered-price'>₹ 9,999</p>
          </div> */}
        </div>
      </div>
    </div>
    <div className='my-5'>
      <div>
        <div className='daywise-course-container d-lg-flex justify-content-between flex-wrap mt-5'>
          <div className='course-detail-card ps-3 pb-3 mb-5' style={{height:'68vh'}}>
            <button className='detail-btn1 mt-3 px-3 py-2 align-start' style={{backgroundColor:'#fff'}}>
              Module-I
            </button>
            <h4 className='daywise-topic mt-3 text-start'>
              <span className='leading-10 text-2xl'>React Foundation</span>
              <br />
              {/* <span className='text-2xl'> & VS Code</span> */}
            </h4>
            <p className='daywise-text mt-3 text-lg px-2'>
              This module is designed for beginners who are new to the world of
              web development.
              <br />
              <br />
            </p>
            <br />
              <ListGroup variant='flush'>
                <ListGroup.Item>Node Modules, VS Code</ListGroup.Item>
                <ListGroup.Item>HTML & Tags, CSS with examples</ListGroup.Item>
                <ListGroup.Item>Responsive Designs & Animations</ListGroup.Item>
                <ListGroup.Item>Array methods in React</ListGroup.Item>
                <ListGroup.Item>React Hooks, Components</ListGroup.Item>
                <ListGroup.Item>API Integration</ListGroup.Item>
                <ListGroup.Item>Get method & map</ListGroup.Item>
                <ListGroup.Item>Scenario Based Projects</ListGroup.Item>
              </ListGroup>
            {/* <button className='detail-btn2 mb-3'>Book a Call</button> */}
          </div>
          <div className='course-detail-card ps-3 pb-3  mb-5 mx-lg-3' style={{height:'68vh'}}>
            <button className='detail-btn1 mt-3 p-2 align-start ' style={{backgroundColor:'#fff'}}>
              Module-II
            </button>
            <h4 className='daywise-topic mt-3 text-start'>
              <span className='leading-10 text-2xl'>React Essentials</span>
            </h4>
            <p className='daywise-text mt-3 text-lg px-2'>
              This module is designed for those who already understand the
              basics and are ready to deepen their knowledge.
              {/* You'll explore
              more advanced concepts like React hooks, lifecycle methods, and
              context API to manage complex state across your application. */}
            </p>
            <br />
            <br />
              <ListGroup variant='flush'>
                <ListGroup.Item>Revision of HTML & CSS</ListGroup.Item>
                <ListGroup.Item>Pre defined functions</ListGroup.Item>
                <ListGroup.Item>Loops</ListGroup.Item>
                <ListGroup.Item>Forms and validation</ListGroup.Item>
                <ListGroup.Item>Post API Integration</ListGroup.Item>
                <ListGroup.Item>State management tool-Redux</ListGroup.Item>
                <ListGroup.Item>Prop Drilling, React Hooks</ListGroup.Item>
                <ListGroup.Item>GET/POST Method Practise</ListGroup.Item>
              </ListGroup>

            {/* <button className='detail-btn2'>Book a Call</button> */}
          </div>
          <div className='course-detail-card ps-3 pb-3  mb-5' style={{height:'68vh'}}>
            <button className='detail-btn1 mt-3 p-2 align-start' style={{backgroundColor:'#fff'}}>
              Module-III
            </button>
            <h4 className='daywise-topic mt-3 text-start'>
              <span className='leading-10 text-2xl'>React Advanced</span>
              <br />
            </h4>
            <p className='daywise-text mt-3 text-lg px-2'>
              This advanced module is tailored for developers who want to master
              React and build high-performance, scalable web apps.
              {/* You'll dive
              deep into topics like custom hooks, React performance
              optimization, SSR, and integrating with APIs and external
              libraries. */}
            </p>
            {/* <button className='detail-btn3'>See Details</button> */}
            <br />
              <ListGroup variant='flush'>
                <ListGroup.Item>Login Authentication</ListGroup.Item>
                <ListGroup.Item>Login Authorization</ListGroup.Item>
                <ListGroup.Item>Props</ListGroup.Item>
                <ListGroup.Item>Context API</ListGroup.Item>
                <ListGroup.Item> Banking Example with redux</ListGroup.Item>
                <ListGroup.Item>API calling in Redux</ListGroup.Item>
                <ListGroup.Item>React Interview Questions</ListGroup.Item>
                <ListGroup.Item>Projects</ListGroup.Item>
              </ListGroup>
            {/* <div>
              <button
                className='detail-btn3'
                // variant='primary'
                onClick={handleShow}
              >
                See Details
              </button>

              <Modal
                className='module-modal'
                size='lg'
                show={show}
                onHide={handleClose}
                aria-labelledby='example-modal-sizes-title-lg'
              >
                <Modal.Header closeButton>
                  <Modal.Title>Module-III React Advanced</Modal.Title>
                </Modal.Header>
                <Modal.Body className='modal-body'>
                  <ul className='d-flex justify-between flex-wrap'>
                    <li className='px-2'>Login Authentication/Authorization</li>
                    <li className='px-2'>Props</li>
                    <li className='px-2'>Context API</li>
                    <li className='px-2'>
                      Banking Example with redux implementation
                    </li>
                    <li className='px-2'>API calling in Redux</li>
                    <li className='px-2'>React Interview Questions</li>
                    <li className='px-2'>Projects</li>
                  </ul>
                </Modal.Body>
                <Modal.Footer>
                  <button variant='secondary' onClick={handleClose}>
                    Close
                  </button>
                  <button variant='primary' onClick={handleClose}>
                    Save Changes
                  </button>
                </Modal.Footer>
              </Modal>
            </div> */}
            {/* <button className='detail-btn2 mb-2'>Book a Call</button> */}
          </div>
        </div>
      </div>
    </div>
    <div className='faqs'>
      <h2 className='faq-heading mx-auto font-semibold text-center'>
        Frequently Asked Questions
      </h2>
      <div className='acc-content d-lg-flex '>
        <div className='faq-left'>
          <img className='faq-img ' src={F} alt='FAQ' />
        </div>
        <div className='faq-right'>
          <Accordion className='faq-acc mt-lg-5 mb-5' flush>
            <Accordion.Item eventKey='0'>
              <Accordion.Header className='faq-header'>
                Can I join Graphene InfoTech as a beginner?
              </Accordion.Header>
              <Accordion.Body className='text-start'>
                Absolutely! Graphene Infotech offers programs suited for both
                beginners and advanced learners. Our curriculum is structured to
                help you build a strong foundation before moving on to more
                complex concepts.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey='1' className='mt-3'>
              <Accordion.Header className='faq-header'>
                Who is eligible to join Graphene InfoTech Training Program?
              </Accordion.Header>
              <Accordion.Body className='text-start'>
                Graphene Infotech courses are open to anyone interested in
                upskilling or starting a career in the digital domain. Whether
                you're a student, a working professional, or a freelancer, our
                programs are designed to meet your needs.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey='2' className='mt-3'>
              <Accordion.Header className='faq-header'>
                Is it necessary to have an engineering background?
              </Accordion.Header>
              <Accordion.Body className='text-start'>
                No, an engineering background is not necessary. Our courses are
                designed for learners from various educational backgrounds.
                Whether you’re new to tech or looking to upskill, we provide the
                foundational knowledge and support needed to help you succeed in
                the field.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey='3' className='mt-3'>
              <Accordion.Header className='faq-header'>
                Can I get help with mock interviews?
              </Accordion.Header>
              <Accordion.Body className='text-start'>
                Yes, we offer dedicated support for mock interviews. Our mentors
                and career coaches will conduct practice interviews to help you
                prepare for real-world situations and enhance your performance.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey='4' className='mt-3'>
              <Accordion.Header className='faq-header'>
                Does Graphene InfoTech provide certificates?
              </Accordion.Header>
              <Accordion.Body className='text-start'>
                Upon successfully completing a course at Graphene Infotech,
                you’ll receive a certificate that verifies your newly gained
                skills. This certificate is a valuable asset to enhance your
                resume and LinkedIn profile, highlighting your expertise.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      </div>
      <footer className='footer-main-container' >
        <div className="footer-block  mt-5">
          <div className="px-5 ul">
            <div className=" py-4 d-lg-flex justify-content-around">
              <div
                style={{
                  flexDirection: "column",
                }}
                className="my-5 col-lg-3 col-md-12 col-sm-12 d-flex justify-content-md-center footer-info"
              >
                <h1>
                  <span>
                    <Image
                      className="mx-auto footer-block-txt mb-2"
                      src={logo}
                      style={{ height: "80px", objectFit: "cover" }}
                    />
                  </span>
                </h1>
                <p
                  className="text-center footer-block-txt my-2"
                  style={{ fontSize: "15px" }}
                >
                  We offer specialized training in React.js, HTML, CSS, and
                  JavaScript, empowering learners with foundational skills for
                  web development and frontend careers.
                </p>
              </div>
              <div className="my-5 footer-links">
                <h4
                  className="text-start footer-block-txt pb-1 page-title"
                  style={{ fontSize: "22px" }}
                >
                  Get in Touch
                </h4>

                <div className="d-flex mt-2">
                  <img
                    style={{ width: "25px", objectFit: "contain" }}
                    src={A}
                  />
                  <h6 className="mt-1 mx-3 footer-block-txt ">
                    +91 9575212142
                  </h6>
                </div>
                <div className="d-flex mt-2">
                  <img
                    style={{ width: "25px", objectFit: "contain" }}
                    src={B}
                  />
                  <h6 className="text-center mt-1 mx-3 footer-block-txt ">
                    info@grapheneinfotech.com
                  </h6>
                </div>
                <div className="d-flex mt-2 text-start">
                  <img
                    style={{
                      width: "25px",
                      objectFit: "contain",
                      textAlign: "start",
                    }}
                    src={C}
                  />
                  <h6 className="text-start mt-1 mx-3 footer-block-txt ">
                    Plot No. 90, Above Dominos,
                    <br /> Infront of Raymond Showroom, <br />
                    Zone-2 MP Nagar, Bhopal, <br />
                    Madhya Pradesh 462023
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <h6 className="text-center pt-3 pb-3 footer-block-txt">
            @2024-2029 <br></br>grapheneinfotech.com
          </h6>
        </div>
      </footer>
      {/* <footer className='footer-main-container'>
        <div className="footer-block  mt-5">
          <div className="px-5 ul">
            <div className=" py-4 d-lg-flex justify-content-around">
              <div
                style={{
                  flexDirection: "column",
                }}
                className="my-5 col-lg-3 col-md-12 col-sm-12 d-flex justify-content-md-center footer-info"
              >
                <h1>
                  <span>
                    <Image
                      className="mx-auto footer-block-txt mb-2"
                      src={logo}
                      style={{ height: "80px", objectFit: "cover" }}
                    />
                  </span>
                </h1>
                <p
                  className="text-center footer-block-txt my-2"
                  style={{ fontSize: "15px" }}
                >
                  We offer specialized training in React.js, HTML, CSS, and
                  JavaScript, empowering learners with foundational skills for
                  web development and frontend careers.
                </p>
              </div>
              <div className="my-5 footer-links">
                <h4
                  className="text-start footer-block-txt pb-1 page-title"
                  style={{ fontSize: "22px" }}
                >
                  Get in Touch
                </h4>

                <div className="d-flex mt-2">
                  <img
                    style={{ width: "25px", objectFit: "contain" }}
                    src={A}
                  />
                  <h6 className="mt-1 mx-3 footer-block-txt ">
                    +91 9575212142
                  </h6>
                </div>
                <div className="d-flex mt-2">
                  <img
                    style={{ width: "25px", objectFit: "contain" }}
                    src={B}
                  />
                  <h6 className="text-center mt-1 mx-3 footer-block-txt ">
                    info@grapheneinfotech.com
                  </h6>
                </div>
                <div className="d-flex mt-2 text-start">
                  <img
                    style={{
                      width: "25px",
                      objectFit: "contain",
                      textAlign: "start",
                    }}
                    src={C}
                  />
                  <h6 className="text-start mt-1 mx-3 footer-block-txt ">
                    Plot No. 90, Above Dominos,
                    <br /> Infront of Raymond Showroom, <br />
                    Zone-2 MP Nagar, Bhopal, <br />
                    Madhya Pradesh 462023
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <h5 className="text-center pt-3 pb-3 footer-block-txt">
            @2024-2029 grapheneinfotech.com
          </h5>
        </div>
      </footer> */}
    </>
  );
};

export default Home;
